import NextImage from 'next/image'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import styles from './styles.module.scss'
import Badge, { BadgeProps } from '@components/ui/Badge'
import { HeaderImage } from 'types/header'
import { getLink } from '@helpers/env'

type FeaturedImageProps = {
  title: string
  handle: string
  buttonText: string
  image: HeaderImage
  width?: number
  height?: number
  badge?: BadgeProps | null
  isTitleCentered?: boolean
  visible?: boolean | null
  onClick: (title: string) => void
}

export default function FeaturedImage({
  title,
  handle,
  buttonText,
  image,
  width,
  height,
  badge,
  isTitleCentered,
  visible = true,
  onClick
}: FeaturedImageProps) {
  return (
    <>
      <div
        className={styles.featuredImage}
        style={
          {
            '--width': `${width}px`,
            '--height': `${height}px`
          } as React.CSSProperties
        }
      >
        <a
          href={getLink(handle)}
          aria-label={`Shop ${title}`}
          onClick={() => onClick(title)}
        >
          {visible && (
            <div className={styles.featuredImage__image}>
              <NextImage
                src={image.url}
                alt={image.title}
                width={width}
                height={height}
              />
            </div>
          )}

          <h3 className={styles.featuredImage__Title}>{title}</h3>

          {badge && (
            <Badge
              classes={styles.featuredImage__badge}
              title={badge.title}
              {...badge}
            />
          )}

          <ButtonMinimal
            classes={styles.featuredImage__imageButton}
            variant="white"
            underlined={true}
          >
            Shop now
          </ButtonMinimal>
          <h3
            className={`${styles.mobileTitle} ${
              isTitleCentered ? styles.mobileTitle__textAlignCenter : ''
            }`}
          >
            {buttonText}
          </h3>
        </a>
      </div>
    </>
  )
}
